import { useQuery } from '@tanstack/react-query';
import { useApiService } from '../../hooks/use-api-service';
import { ExpenseClaimsList } from './expense-claims-list';

export function ExpenseClaimsPage() {
  const { api, dataMode } = useApiService();

  const { data: expenseClaims = [], isLoading } = useQuery({
    queryKey: ['expenseClaims', dataMode],
    queryFn: () => api.getExpenseClaims(),
  });

  return (
    <div className="flex flex-col gap-6 p-4 md:p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">Expense Claims</h1>
          <p className="text-muted-foreground mt-1 text-sm md:text-base">
            View and manage all your expense claims
          </p>
        </div>
      </div>

      <ExpenseClaimsList expenses={expenseClaims} isLoading={isLoading} />
    </div>
  );
}
